(function(){
  // ---------- carousel (15 slides · gallery v3 24.10.) · native scroll-snap swipe (slide follows the finger at once) · arrows · dots ----------
  // autoplay 6 s + 700 ms slide = Alpha fr2 hero (slick autoplaySpeed 6000, speed 700) · other slides preload after load (Alpha: lazyLoad progressive)
  var car=document.getElementById('car'), track=car.querySelector('.car-track'), slides=[].filter.call(track.children,function(x){return !x.hidden;}), n=slides.length, i=0, dots=car.querySelector('.car-dots'), timer, raf=0, held=false, lw=track.clientWidth;
  for(var k=0;k<n;k++){var b=document.createElement('button');b.setAttribute('aria-label','Slide '+(k+1));(function(k){b.onclick=function(){go(k);rest();};})(k);dots.appendChild(b);}
  function mark(k){i=k;[].forEach.call(dots.children,function(d,j){d.classList.toggle('on',j===i);});}
  function ease(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;}
  function stopAnim(){if(raf){cancelAnimationFrame(raf);raf=0;track.style.scrollSnapType='';}}
  function go(k){k=(k+n)%n;mark(k);stopAnim();var from=track.scrollLeft,to=k*track.clientWidth,t0=null;if(Math.abs(to-from)<1)return;track.style.scrollSnapType='none';
    raf=requestAnimationFrame(function f(t){if(t0===null)t0=t;var q=Math.min(1,(t-t0)/700);track.scrollLeft=from+(to-from)*ease(q);if(q<1)raf=requestAnimationFrame(f);else{raf=0;track.style.scrollSnapType='';}});}
  function rest(){clearInterval(timer);timer=setInterval(function(){if(!held)go(i+1);},6000);}
  car.querySelector('.p').onclick=function(){go(i-1);rest();};
  car.querySelector('.n').onclick=function(){go(i+1);rest();};
  track.addEventListener('touchstart',function(){held=true;stopAnim();},{passive:true});
  track.addEventListener('touchend',function(){held=false;rest();},{passive:true});
  track.addEventListener('scroll',function(){if(raf)return;var k=Math.round(track.scrollLeft/track.clientWidth);if(k!==i&&k>=0&&k<n)mark(k);},{passive:true});
  window.addEventListener('resize',function(){if(track.clientWidth!==lw){lw=track.clientWidth;stopAnim();track.scrollLeft=i*lw;}});
  window.addEventListener('load',function(){[].forEach.call(track.querySelectorAll('img[loading="lazy"]'),function(im){im.loading='eager';});});
  mark(0);rest();window.__car={go:go,stop:function(){clearInterval(timer);}};

  // ---------- all CTAs scroll to the offer (no checkout) ----------
  var offer=document.getElementById('offer');
  [].forEach.call(document.querySelectorAll('.go'),function(a){a.addEventListener('click',function(e){e.preventDefault();offer.scrollIntoView({behavior:'smooth',block:'start'});});});

  // ---------- sticky bar: shows once the hero CTA is out of view ----------
  var sticky=document.getElementById('sticky'), heroCta=document.getElementById('heroCta');
  if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('on',!e.isIntersecting && e.boundingClientRect.top<0);});}).observe(heroCta);}

  // ---------- tabs ----------
  [].forEach.call(document.querySelectorAll('.tab'),function(t){t.addEventListener('click',function(){
    [].forEach.call(document.querySelectorAll('.tab'),function(x){x.classList.toggle('on',x===t);});
    [].forEach.call(document.querySelectorAll('.pane'),function(p){p.classList.toggle('on',p.id===t.dataset.tab);});
  });});
  var rl=document.querySelector('.rlink'); if(rl) rl.addEventListener('click',function(e){e.preventDefault();document.getElementById('reviews').scrollIntoView({behavior:'smooth'});});

  // ---------- before/after marquee: 12 static tiles, cloned once for the loop ----------
  var ba=document.getElementById('baTrack');
  if(ba) [].slice.call(ba.children).forEach(function(t){var c=t.cloneNode(true);c.setAttribute('aria-hidden','true');ba.appendChild(c);});

  // ---------- review carousel: 3 text reviews · phone: swipe (scroll-snap, 86 % cards, next one peeks) + dots · desktop: arrows + mouse drag ----------
  var rs=document.getElementById('rs'), rsD=document.getElementById('rsD'), rcs=[].slice.call(rs.children), stops=[];
  function rsBuild(){var max=rs.scrollWidth-rs.clientWidth, pl=parseFloat(getComputedStyle(rs).paddingLeft)||0; stops=[];
    rcs.forEach(function(c){var x=Math.max(0,Math.min(max,c.offsetLeft-pl));if(!stops.length||x-stops[stops.length-1]>8)stops.push(x);});
    rsD.innerHTML='';stops.forEach(function(x,k){var b=document.createElement('button');b.setAttribute('aria-label','Review '+(k+1));b.onclick=function(){rs.scrollTo({left:stops[k],behavior:'smooth'});};rsD.appendChild(b);});rsMark();}
  function rsIdx(){var x=rs.scrollLeft,best=0;stops.forEach(function(v,k){if(Math.abs(v-x)<Math.abs(stops[best]-x))best=k;});return best;}
  function rsMark(){var k=rsIdx();[].forEach.call(rsD.children,function(d,j){d.classList.toggle('on',j===k);});}
  function rsTo(k){rs.scrollTo({left:stops[Math.max(0,Math.min(stops.length-1,k))],behavior:'smooth'});}
  rs.addEventListener('scroll',rsMark,{passive:true});
  window.addEventListener('resize',rsBuild); window.addEventListener('load',rsBuild);
  document.getElementById('rsP').onclick=function(){rsTo(rsIdx()-1);};
  document.getElementById('rsN').onclick=function(){rsTo(rsIdx()+1);};
  var dx0=null, sl0=0, k0=0, moved=false;
  rs.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;dx0=e.clientX;sl0=rs.scrollLeft;k0=rsIdx();moved=false;rs.style.scrollSnapType='none';rs.classList.add('drag');});
  window.addEventListener('pointermove',function(e){if(dx0===null)return;var d=e.clientX-dx0;if(Math.abs(d)>3)moved=true;rs.scrollLeft=sl0-d;});
  window.addEventListener('pointerup',function(){if(dx0===null)return;var d=rs.scrollLeft-sl0, k=rsIdx();dx0=null;rs.classList.remove('drag');
    if(k===k0&&Math.abs(d)>40)k+=d>0?1:-1;
    rsTo(k);setTimeout(function(){rs.style.scrollSnapType='';},500);});
  rs.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  rs.addEventListener('dragstart',function(e){e.preventDefault();});
  rsBuild();

  // ---------- plan picker (men PDP buy box): select a card, update the buy-once line ----------
  var once=document.getElementById('bbOnce');
  [].forEach.call(document.querySelectorAll('.bb-plan'),function(p){p.addEventListener('click',function(){
    [].forEach.call(document.querySelectorAll('.bb-plan'),function(x){x.classList.toggle('on',x===p);x.setAttribute('aria-checked',x===p?'true':'false');});
    if(once) once.textContent=p.dataset.once;
  });});

  // ---------- supplement facts modal ----------
  var md=document.getElementById('md');
  function openM(){md.classList.add('on');document.body.classList.add('lock');}
  function closeM(){md.classList.remove('on');document.body.classList.remove('lock');}
  [].forEach.call(document.querySelectorAll('[data-modal]'),function(b){b.addEventListener('click',openM);});
  [].forEach.call(md.querySelectorAll('[data-close]'),function(b){b.addEventListener('click',closeM);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeM();});

  // ---------- draft-only bits (?draft) ----------
  if(/[?&]draft\b/.test(location.search)) [].forEach.call(document.querySelectorAll('[data-draft]'),function(e){e.hidden=false;});

  // ---------- Light Labs badge (like the PDP) + Inter: Shopify strips <script src> / <link> from page content ----------
  [].forEach.call(document.querySelectorAll('.pdp-ll'),function(box){ if(!box.querySelector('lightlabs-widget')){ var w=document.createElement('lightlabs-widget'); w.setAttribute('company-id','1218'); w.setAttribute('product-id','8587'); w.style.display='block'; box.appendChild(w); } });
  (function(){ var s=document.createElement('script'); s.async=true; s.src='https://app.lightlabs.com/assets/ll-pip-widget-v5.js'; document.head.appendChild(s); })();
  (function(){ var l=document.createElement('link'); l.rel='stylesheet'; l.href='https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'; document.head.appendChild(l); })();
})();



(function(){var c=document.getElementById('bcar');if(!c)return;var tr=c.querySelector('.car-track'),sl=[].slice.call(tr.children),d=c.querySelector('.car-dots'),i=0;sl.forEach(function(_,k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Photo '+(k+1));b.addEventListener('click',function(){go(k)});d.appendChild(b);});function go(k){i=(k+sl.length)%sl.length;tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});mark();}function mark(){[].forEach.call(d.children,function(b,k){b.classList.toggle('on',k===i)});}tr.addEventListener('scroll',function(){var k=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));if(k!==i){i=k;mark();}},{passive:true});c.querySelector('.car-arr.p').addEventListener('click',function(){go(i-1)});c.querySelector('.car-arr.n').addEventListener('click',function(){go(i+1)});mark();})();



/* =====================================================================
   CART DRAWER on the funnel · Dominik 24.10.2026: "Add to Cart" opens the men PDP cart here, the visitor stays on the page.
   Logic = men theme 206800453972 · assets/theme.js (window.MYOTIDE_Cart: open/close, height lock v6, changePlan,
   setQty, upgradeToSubscribe, reconcileGifts) + sections/cart-drawer.liquid (labels, discounts, totals),
   rebuilt on the Shopify AJAX Cart API (/cart.js · /cart/add.js · /cart/change.js · /cart/update.js).
   No-JS fallback: .bb-atc / #bbOnce keep their href to the men PDP.
   ===================================================================== */
(function(){
  var D=document, W=window;
  var drawer=D.getElementById('lpcd'), back=D.getElementById('lpcd-backdrop');
  if(!drawer || !back || !W.fetch || !W.Promise) return;
  var $=function(k){ return drawer.querySelector('[data-cd="'+k+'"]'); };

  // ---------- config · runtime values from the store win, these are the fallbacks (Admin API read 24.10.2026) ----------
  var HANDLE='preserve-stack-strength';
  var CFG={
    productId: 15903308841300,
    variants: {1:57794525004116, 3:57794525036884, 6:57794525069652},   // MYO-001 / 002 / 003 = 1 / 3 / 6 bags
    plans:    {1:690913050964,   3:690913083732,   6:690913116500},     // Loop "Every 30 days" / "Every 3 months" / "Every 6 months"
    // Men gifts = product metafield custom.freebies_on_subscription = what the men PDP form posts as items[n] with
    // properties[_subProduct]=true + parent_id. Read at runtime from the PDP hero section (GIFT_SECTION); this list is the fallback:
    // 5x Electrolyte Sticks (orange) · Grip Trainer · Pocket Pill Dispenser · High-Fiber & Protein Recipes (orange)
    gifts:    [57847836344660, 57833125642580, 57833125675348, 57847837294932]
  };
  var GIFT_SECTION='pdp-hero-men';
  var PRICES={}, PTITLE='The Preserve Stack';   // from product .js: cents per bag count + product title → pending line (instant open)
  var LEGACY_BAGS={55960842633556:1, 55960842666324:3, 55960842699092:6};   // main Preserve Stack variants (theme fallback map)
  var SHIP_THRESHOLD=4500;                                                // section setting free_shipping_threshold = 45
  var PLAN_PCT={monthly:20, '3month':30, '6month':40};                     // theme: marketing-rounded %
  var PLAN_LABEL={monthly:'Every Month', '3month':'Every 3 Months', '6month':'Every 6 Months', onetime:'One-Time Purchase'};
  var PLAN_BAGS={monthly:1, '3month':3, '6month':6};
  var BAGS_PLAN={1:'monthly', 3:'3month', 6:'6month'};

  // ---------- helpers ----------
  function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function req(url, body){
    var o={credentials:'same-origin', headers:{Accept:'application/json'}};
    if(body){ o.method='POST'; o.headers['Content-Type']='application/json'; o.body=JSON.stringify(body); }
    return fetch(url, o).then(function(r){
      return r.text().then(function(t){
        var j=null; try{ j=t ? JSON.parse(t) : {}; }catch(e){}
        if(!r.ok || !j){ var e=new Error((j && (j.description || j.message)) || ('HTTP '+r.status)); e.status=r.status; throw e; }
        return j;
      });
    });
  }
  function getCart(){ return req('/cart.js').then(function(c){ if(!c || !c.items) throw new Error('Cart could not be read'); return c; }); }
  function errText(e){ return (e && e.message) ? e.message : 'unknown error'; }
  var cart=null;
  function money(cents){
    var cur=(cart && cart.currency) || 'USD', v=(Number(cents)||0)/100;
    try{ return new Intl.NumberFormat('en-US', {style:'currency', currency:cur, currencyDisplay:'narrowSymbol'}).format(v); }
    catch(e){ return '$'+v.toFixed(2); }
  }
  function toast(msg, type){   // theme toast (#cd-toast)
    var t=D.getElementById('lpcd-toast');
    if(!t){
      t=D.createElement('div'); t.id='lpcd-toast'; t.setAttribute('role','alert');
      t.style.cssText='position:fixed;top:20px;right:20px;z-index:10000;padding:14px 20px;border-radius:8px;font:600 13px/1.35 Inter,system-ui,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,.2);transition:opacity .3s;color:#fff;max-width:min(380px,calc(100vw - 40px));opacity:0;pointer-events:none';
      D.body.appendChild(t);
    }
    t.style.background = type==='error' ? '#D04040' : '#14120F';
    t.textContent=msg; t.style.opacity='1';
    clearTimeout(t._tm); t._tm=setTimeout(function(){ t.style.opacity='0'; }, 4000);
  }

  // ---------- store config (product .js + gift list from the men PDP form), loaded once ----------
  var cfgP=null;
  function loadConfig(){
    if(cfgP) return cfgP;
    var pP=req('/products/'+HANDLE+'.js').then(function(p){
      if(p && p.id) CFG.productId=p.id;
      if(p && p.title) PTITLE=p.title;
      var vs=(p && p.variants) || [];
      [1,3,6].forEach(function(b){
        var v=vs.filter(function(x){ return x.id===CFG.variants[b]; })[0] || vs.filter(function(x){ return parseInt(x.title,10)===b; })[0];
        if(!v) return;
        CFG.variants[b]=v.id;
        var a=(v.selling_plan_allocations || [])[0];
        if(a && a.selling_plan_id) CFG.plans[b]=a.selling_plan_id;
        if(v.price) PRICES[b]={once:v.price, sub:(a && a.price) || 0};
      });
    }).catch(function(e){ console.warn('[LP cart] product .js not read, using fallback ids:', errText(e)); });
    var gP=fetch('/products/'+HANDLE+'?section_id='+GIFT_SECTION, {credentials:'same-origin'}).then(function(r){
      if(!r.ok) throw new Error('HTTP '+r.status);
      return r.text();
    }).then(function(h){
      var ids=[], m, re=/name="items\[\d+\]\[id\]"[^>]*?value="(\d+)"/g;
      while((m=re.exec(h))){ var id=Number(m[1]); if(ids.indexOf(id)<0) ids.push(id); }
      if(ids.length && ids.length<=8) CFG.gifts=ids;
    }).catch(function(e){ console.warn('[LP cart] gift list not read from the PDP, using fallback gifts:', errText(e)); });
    cfgP=Promise.all([pP, gP]);
    return cfgP;
  }
  function configReady(){ return Promise.race([loadConfig(), wait(3500)]); }   // never block the add longer than 3.5 s
  var offerEl=D.getElementById('offer');
  if(offerEl && 'IntersectionObserver' in W){
    var io=new IntersectionObserver(function(es){ if(es.some(function(e){ return e.isIntersecting; })){ loadConfig(); io.disconnect(); } }, {rootMargin:'1200px 0px'});
    io.observe(offerEl);
  }
  // speed (24.10.2026): read the store config right after the page start, so a click never waits for it · observer + pointerdown stay
  if(W.requestIdleCallback) W.requestIdleCallback(function(){ loadConfig(); }, {timeout:1500});
  else setTimeout(function(){ loadConfig(); }, 1500);

  // ---------- line helpers (theme cart-drawer.liquid) ----------
  function isGift(it){ return !!(it.properties && it.properties._subProduct); }
  function isStack(it){ return it.product_id===CFG.productId || it.handle===HANDLE; }
  function bagsOf(it){
    var v=Number(it.variant_id);
    for(var b in CFG.variants){ if(CFG.variants[b]===v) return Number(b); }
    if(LEGACY_BAGS[v]) return LEGACY_BAGS[v];
    var m=/(\d+)\s*bag/i.exec(it.variant_title || '');
    return m ? Number(m[1]) : 1;
  }
  function planKeyOf(it){
    var spa=it.selling_plan_allocation;
    if(!spa) return 'onetime';
    var n=((spa.selling_plan && spa.selling_plan.name) || '').toLowerCase();
    // Plan-Label-Matcher v2 (theme lock): Monthly FIRST so "every 3" never swallows "Every 30 days"
    if(/30 day|every 30|monthly|1 month|every month|1mo/.test(n)) return 'monthly';
    if(/6 month|6-month|every 6 month|180 day|6mo/.test(n)) return '6month';
    if(/3 month|3-month|every 3 month|90 day|3mo/.test(n)) return '3month';
    return BAGS_PLAN[bagsOf(it)] || '3month';   // fallback by variant (each Loop plan is bound to one variant)
  }
  function anchorUnit(it, bags){   // strike-through anchor per unit · theme: $84.90 × bag count
    var spa=it.selling_plan_allocation || {};
    if(isStack(it) && (!cart || cart.currency==='USD')) return 8490*bags;
    if(spa.compare_at_price && spa.compare_at_price>spa.price) return spa.compare_at_price;
    return it.original_price || it.price || 0;
  }

  // ---------- render ----------
  var CHEV='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
  function itemHTML(it){
    var stack=isStack(it), pk=planKeyOf(it), sub=pk!=='onetime', bags=bagsOf(it), qty=it.quantity;
    var label = stack ? PLAN_LABEL[pk] : (sub ? it.selling_plan_allocation.selling_plan.name : PLAN_LABEL.onetime);
    var lineLabel = label + (stack && !sub && bags>1 ? ' · '+bags+' bags' : '');
    var disc=0, pct=0, strike=0;
    if(sub){
      var anchor=anchorUnit(it, bags)*qty;
      disc=Math.max(0, anchor-it.final_line_price); strike=anchor;
      pct = stack ? (PLAN_PCT[pk]||0) : (anchor ? Math.round(disc*100/anchor) : 0);
    } else if(it.original_line_price>it.final_line_price){
      disc=it.original_line_price-it.final_line_price; strike=it.original_line_price;
      pct=Math.round(disc*100/it.original_line_price);
    }
    var img=it.image ? (it._rawImage ? it.image : it.image+(it.image.indexOf('?')>-1 ? '&' : '?')+'width=200') : '';   // _rawImage = pending line (card thumb)
    var h='<li class="cd-item" data-key="'+esc(it.key)+'" data-variant-id="'+esc(it.variant_id)+'">'
      +'<div class="cd-item-top"><div class="cd-item-img">'+(img ? '<img src="'+esc(img)+'" alt="'+esc(it.product_title)+'">' : '')+'</div>'
      +'<div class="cd-item-info">'
      +'<div class="cd-item-row"><div class="cd-item-title">'+esc(it.product_title)+'</div><div class="cd-item-final">'+money(it.final_line_price)+'</div></div>'
      +'<div class="cd-item-plan-line"><span class="cd-item-plan">'+esc(lineLabel)+'</span>'+(disc>0 ? '<span class="cd-item-strike">'+money(strike)+'</span>' : '')+'</div>'
      +(disc>0 ? '<div class="cd-item-discount">Auto-Refill Discount: '+pct+'% Off: -'+money(disc)+'</div>' : '')
      +'<div class="cd-item-controls">';
    if(stack){
      h+='<div class="cd-plan-wrap"><button type="button" class="cd-pill cd-pill-plan" data-cd-plan-toggle aria-haspopup="listbox" aria-expanded="false"><span class="cd-pill-label">'+esc(label)+'</span>'+CHEV+'</button>'
        +'<ul class="cd-plan-menu" role="listbox" aria-label="Delivery plan" hidden>'
        +['monthly','3month','6month','onetime'].map(function(k){
          return '<li class="cd-plan-option'+(k===pk ? ' is-selected' : '')+'" data-plan-key="'+k+'" role="option" tabindex="0" aria-selected="'+(k===pk)+'">'+PLAN_LABEL[k]+(PLAN_PCT[k] ? ' <span class="cd-plan-save">SAVE '+PLAN_PCT[k]+'%</span>' : '')+'</li>';
        }).join('')
        +'</ul></div>';
    }
    var max=Math.max(10, qty), opts='';
    for(var n=0; n<=max; n++) opts+='<option value="'+n+'"'+(n===qty ? ' selected' : '')+'>'+n+'</option>';
    h+='<div class="cd-pill cd-pill-qty-select"><select class="cd-qty-select" data-cd-qty aria-label="Quantity (set to 0 to remove)">'+opts+'</select>'
      +'<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="cd-qty-arrow" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg></div>'
      +'</div></div></div></li>';
    return h;
  }
  function render(){
    var c=cart || {items:[], total_price:0};
    var lines=c.items.filter(function(it){ return !isGift(it); });
    var count=lines.reduce(function(s, it){ return s+it.quantity; }, 0);
    var hasSub=lines.some(function(it){ return !!it.selling_plan_allocation; });
    var hasOnceStack=lines.some(function(it){ return isStack(it) && !it.selling_plan_allocation; });

    var total=c.total_price || 0;
    $('ship').textContent = total>=SHIP_THRESHOLD ? "You've unlocked Free Prime Shipping" : 'Add '+money(SHIP_THRESHOLD-total)+' more for Free Prime Shipping';
    $('fill').style.width = (total>0 ? Math.min(100, Math.round(total*100/SHIP_THRESHOLD)) : 0)+'%';
    var cnt=$('count'); cnt.textContent=count; cnt.hidden = count<1;

    $('wait').hidden=true;
    var empty = c.items.length===0 || lines.length===0;
    $('empty').hidden=!empty;
    ['items','gifts','benefits','footer'].forEach(function(k){ $(k).hidden=empty; });
    if(empty){ $('items').innerHTML=''; return; }

    $('items').innerHTML=lines.map(itemHTML).join('');
    $('gifts-content').classList.toggle('cd-gifts-greyed', !hasSub);
    drawer.querySelector('[data-cd-upgrade]').hidden = hasSub || !hasOnceStack;

    // footer totals (theme: anchor = $84.90 × bags × qty for sub lines)
    var tDisc=0, tOrig=0, maxPct=0;
    c.items.forEach(function(it){
      if(it.selling_plan_allocation){
        var anchor=anchorUnit(it, bagsOf(it))*it.quantity, d=anchor-it.final_line_price;
        if(d>0){ tDisc+=d; tOrig+=anchor; } else tOrig+=it.final_line_price;
        var pk=planKeyOf(it);
        if(pk==='6month') maxPct=40; else if(pk==='3month' && maxPct<30) maxPct=30; else if(pk==='monthly' && maxPct<20) maxPct=20;
      } else tOrig+=it.final_line_price;
    });
    $('disc').hidden = !(tDisc>0);
    $('disc-label').textContent='Auto-Refill Discount: '+maxPct+'% Off';
    $('disc-amt').textContent='-'+money(tDisc);
    var st=$('strike'); st.hidden=!(tDisc>0); st.textContent=money(tOrig);
    $('subtotal').textContent=money(total);
  }

  function renderError(){
    var w=$('wait'); w.hidden=false; w.textContent='Your cart could not be loaded. Please try again.';
    ['empty','items','gifts','benefits','footer'].forEach(function(k){ $(k).hidden=true; });
  }

  // ---------- gift reconcile (theme 2026-07-21): gift qty = summed qty of subscription stack lines ----------
  var rebuildFailed=false;
  function reconcile(c){
    var gifts=CFG.gifts; if(!gifts.length) return Promise.resolve(false);
    var subs=c.items.filter(function(it){ return isStack(it) && it.selling_plan_allocation && !isGift(it); });
    var want=subs.reduce(function(s, it){ return s+it.quantity; }, 0);
    var gl=c.items.filter(function(it){ return isGift(it) && gifts.indexOf(it.variant_id)>-1; });
    var missing=gifts.filter(function(v){ return !gl.some(function(it){ return it.variant_id===v; }); });
    // stale gifts (Dominik 24.10.2026 "einfach ausgetauscht mit den blauen, aber nicht zusätzlich"): gift children of a men's stack line
    // that are not in today's gift list (old blue electrolytes/recipes from carts filled before the orange men-only gifts) force the
    // rebuild below, so today's gifts replace them in the right order instead of sitting on top
    var stackKeys=c.items.filter(function(it){ return isStack(it) && !isGift(it); }).map(function(it){ return it.key; });
    var stale=c.items.filter(function(it){ return isGift(it) && gifts.indexOf(it.variant_id)<0 && it.parent_relationship && stackKeys.indexOf(it.parent_relationship.parent_key)>-1; });

    if(want>0 && (missing.length || stale.length) && !rebuildFailed){
      // A gift is missing (e.g. the plan switch removed the parent with its children): rebuild stack + gifts in ONE add call,
      // parent first, same shape as the PDP form → checkout keeps the parent/child nesting.
      var zero={};
      subs.forEach(function(it){ zero[it.key]=0; }); gl.forEach(function(it){ zero[it.key]=0; }); stale.forEach(function(it){ zero[it.key]=0; });
      var items=subs.map(function(it){ return {id:it.variant_id, quantity:it.quantity, selling_plan:it.selling_plan_allocation.selling_plan.id}; });
      var anchorId=items[0].id;
      gifts.forEach(function(v){ items.push({id:v, quantity:want, properties:{_subProduct:'true'}, parent_id:anchorId}); });
      return req('/cart/update.js', {updates:zero}).then(function(){
        return req('/cart/add.js', {items:items});
      }).catch(function(e){
        rebuildFailed=true;   // never loop: one rebuild attempt per page view
        console.error('[LP cart] gift rebuild failed:', errText(e));
        // never lose the paid product: restore the stack lines first, then the gifts without nesting
        return req('/cart/add.js', {items:items.slice(0, subs.length)}).catch(function(){}).then(function(){
          return req('/cart/add.js', {items:items.slice(subs.length).map(function(x){ return {id:x.id, quantity:x.quantity, properties:x.properties}; })}).catch(function(){});
        });
      }).then(function(){ return true; });
    }
    // nothing missing → sync quantities in place (keeps the nesting) and zero duplicate lines
    var upd={}, n=0;
    gifts.forEach(function(v){
      var ls=gl.filter(function(it){ return it.variant_id===v; });
      if(!ls.length) return;
      if(want===0 || ls[0].quantity!==want){ upd[ls[0].key]=want; n++; }
      for(var i=1; i<ls.length; i++){ upd[ls[i].key]=0; n++; }
    });
    stale.forEach(function(it){ upd[it.key]=0; n++; });
    if(!n) return Promise.resolve(false);
    return req('/cart/update.js', {updates:upd}).then(function(){ return true; });
  }

  // refresh = reconcile, then read the cart and render (theme: refresh() → runGiftReconcile + re-render)
  function refresh(){
    return configReady().then(getCart).then(function(c){
      return reconcile(c).catch(function(e){ console.error('[LP cart] gift reconcile failed:', errText(e)); return false; })
        .then(function(changed){ return changed ? getCart() : c; });
    }).then(function(c){ cart=c; render(); return c; });
  }

  // mutations run one after another; the drawer shows the busy state; the real cart is always re-rendered afterwards
  var chain=Promise.resolve(), busy=0;
  function mutate(fn){
    busy++; drawer.classList.add('is-loading');
    chain=chain.then(function(){
      return Promise.resolve().then(fn).catch(function(e){ toast('Could not update your cart: '+errText(e), 'error'); })
        .then(refresh).catch(function(e){ toast('Could not load your cart: '+errText(e), 'error'); });
    }).then(function(){ if(--busy<=0){ busy=0; drawer.classList.remove('is-loading'); } });
    return chain;
  }

  function findLine(c, key, vid){
    return c.items.filter(function(i){ return i.key===key; })[0]
      || c.items.filter(function(i){ return String(i.variant_id)===String(vid) && !isGift(i); })[0];   // key can go stale after a reconcile
  }

  // plan switch (theme changePlan · lock 2026-06-29 bag-count preservation)
  function changePlan(key, vid, planKey){
    return configReady().then(getCart).then(function(c){
      var it=findLine(c, key, vid);
      if(!it) throw new Error('Item not found in cart');
      if(planKeyOf(it)===planKey) return;
      var wasOnce=!it.selling_plan_allocation, curBags=bagsOf(it)*(it.quantity||1), nv, nq, np=null;
      if(planKey==='onetime'){
        nv=it.variant_id; nq=it.quantity;                                   // funnel buy-once model: same pack, no plan
      } else {
        var b=PLAN_BAGS[planKey]; nv=CFG.variants[b]; np=CFG.plans[b];
        nq = wasOnce ? Math.max(1, Math.round(curBags/b)) : 1;              // one-time → sub keeps the supply · sub → sub = 1
      }
      // the line's gifts follow it: remove them with the parent, re-add them under the new parent
      var otherSubs=c.items.filter(function(i){ return i.key!==it.key && isStack(i) && i.selling_plan_allocation && !isGift(i); });
      var giftLines=c.items.filter(function(i){ return isGift(i) && CFG.gifts.indexOf(i.variant_id)>-1; });
      var zero={}; zero[it.key]=0;
      if(!otherSubs.length) giftLines.forEach(function(g){ zero[g.key]=0; });
      var items=[{id:nv, quantity:nq}];
      if(np){
        items[0].selling_plan=np;
        if(!otherSubs.length) CFG.gifts.forEach(function(g){ items.push({id:g, quantity:nq, properties:{_subProduct:'true'}, parent_id:nv}); });
      }
      var orig={id:it.variant_id, quantity:it.quantity};
      if(it.selling_plan_allocation) orig.selling_plan=it.selling_plan_allocation.selling_plan.id;
      return req('/cart/update.js', {updates:zero}).then(function(){
        return req('/cart/add.js', {items:items}).catch(function(e){
          // never lose the product: plan without gifts (reconcile re-adds them), else put the old line back
          return req('/cart/add.js', {items:[items[0]]}).catch(function(){
            return req('/cart/add.js', {items:[orig]}).catch(function(){}).then(function(){ throw e; });
          });
        });
      });
    });
  }
  function setQty(key, vid, qty){   // theme setQty / removeItem (0 = remove) · gifts follow via reconcile
    return getCart().then(function(c){
      var it=findLine(c, key, vid);
      if(!it) return;
      return req('/cart/change.js', {id:it.key, quantity:qty});
    });
  }
  function upgrade(){   // theme upgradeToSubscribe · plan = the pack the visitor bought once (1/3/6 bags), gifts included
    return getCart().then(function(c){
      var it=c.items.filter(function(i){ return isStack(i) && !i.selling_plan_allocation && !isGift(i); })[0];
      if(!it) return;
      return changePlan(it.key, it.variant_id, BAGS_PLAN[bagsOf(it)] || '3month');
    });
  }

  // ---------- open / close · ⚠ iOS VIEWPORT-HEIGHT LOCK v6 (theme.js 2026-05-28 · DO NOT REVERT WITHOUT TESTING) ----------
  // (a) JS sets HEIGHT ONLY, skipped during pinch-zoom (scale > 1) · (b) iOS-safe body lock via position:fixed
  // (c) visualViewport.resize only — never a visualViewport.scroll listener, never width/top/left, never body{overflow:hidden}
  function setCartViewportHeight(){
    var vv=W.visualViewport;
    if(vv && vv.scale>1.01) return;
    var h=(vv && vv.height) || W.innerHeight;
    drawer.style.height=h+'px'; back.style.height=h+'px';
  }
  function clearCartViewportStyles(){ drawer.style.height=''; back.style.height=''; }
  var savedY=0, locked=false;
  function lockBodyScroll(){
    if(locked) return; locked=true;
    savedY=W.scrollY || W.pageYOffset || 0;
    var s=D.body.style; s.position='fixed'; s.top='-'+savedY+'px'; s.left='0'; s.right='0'; s.width='100%';
  }
  function unlockBodyScroll(){
    if(!locked) return; locked=false;
    var s=D.body.style; s.position=''; s.top=''; s.left=''; s.right=''; s.width='';
    var html=D.documentElement, sb=html.style.scrollBehavior;
    html.style.scrollBehavior='auto';   // the page has html{scroll-behavior:smooth} → restore the spot instantly
    W.scrollTo(0, savedY);
    html.style.scrollBehavior=sb;
  }
  var lastFocus=null;
  function isOpen(){ return drawer.classList.contains('open'); }
  function open(trigger){
    lastFocus=trigger || D.activeElement;
    setCartViewportHeight();
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    back.classList.add('open');
    lockBodyScroll();
    var x=drawer.querySelector('[data-cd-close]');
    if(x) try{ x.focus({preventScroll:true}); }catch(e){}
  }
  function close(){
    if(!isOpen()) return;
    closeMenus();
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true');
    back.classList.remove('open');
    unlockBodyScroll();
    clearCartViewportStyles();
    if(lastFocus && lastFocus.focus) try{ lastFocus.focus({preventScroll:true}); }catch(e){}
  }
  if(W.visualViewport) W.visualViewport.addEventListener('resize', function(){ if(isOpen()) setCartViewportHeight(); });
  else W.addEventListener('resize', function(){ if(isOpen()) setCartViewportHeight(); });

  // ---------- funnel buttons: Add to Cart (selected plan + gifts) · Buy once (same pack, no plan, no gifts) ----------
  function selectedBags(){
    var plans=[].slice.call(D.querySelectorAll('.bb-plans .bb-plan')), on=D.querySelector('.bb-plans .bb-plan.on');
    var b=on ? Number(on.getAttribute('data-bags')) : 0;
    if(!b && on) b=[1,3,6][plans.indexOf(on)] || 0;
    return CFG.variants[b] ? b : 3;
  }
  // ---------- instant open (speed · Dominik 24.10.2026 "dauert zu lange, bis sich der Warenkorb öffnet") ----------
  // The drawer opens AT the click, before any request. The chosen line is drawn at once through the same itemHTML/render as the
  // real cart (store prices + title from product .js, else the plan card's own prices), merged into the last real cart if known.
  // /cart/add.js + /cart.js run in the background, then the real cart replaces it. No prices known → "Adding to your cart…" spinner.
  function cardCents(s){ var m=/\$\s*([\d,]+(?:\.\d{1,2})?)/.exec(s || ''); return m ? Math.round(parseFloat(m[1].replace(/,/g,''))*100) : 0; }
  function pendingLine(kind, b, cur){
    var vid=CFG.variants[b], plan=kind==='sub' ? CFG.plans[b] : null, p=PRICES[b];
    var card=D.querySelector('.bb-plans .bb-plan[data-bags="'+b+'"]'), th=card && card.querySelector('img');
    if(!p || !p.once || (plan && !p.sub)){   // product .js not read (yet) → the plan card: "$59.90/mo" × bags · data-once "Buy once for $254.70"
      var mo=card ? cardCents((card.querySelector('.bb-pc b') || {}).textContent) : 0, once=card ? cardCents(card.getAttribute('data-once')) : 0;
      p = (cur==='USD' && mo && once) ? {sub:mo*b, once:once} : null;
    }
    if(!vid || !p) return null;
    var unit=plan ? p.sub : p.once;
    return {key:'lpcd-pending', id:vid, variant_id:vid, product_id:CFG.productId, handle:HANDLE, product_title:PTITLE,
      variant_title:b+(b>1 ? ' bags' : ' bag'), quantity:1, price:unit, original_price:unit, final_price:unit,
      line_price:unit, original_line_price:unit, final_line_price:unit, properties:{},
      image:th ? (th.currentSrc || th.src) : '', _rawImage:true,
      selling_plan_allocation: plan ? {price:unit, compare_at_price:p.once, selling_plan:{id:plan, name:''}} : null};
  }
  function pendingCart(kind, b){
    var cur=(cart && cart.currency) || (W.Shopify && W.Shopify.currency && W.Shopify.currency.active) || 'USD';
    var line=pendingLine(kind, b, cur); if(!line) return null;
    var c=(cart && cart.items) ? JSON.parse(JSON.stringify(cart)) : {items:[], total_price:0};
    var plan=line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.id : null;
    var same=c.items.filter(function(it){ return !isGift(it) && Number(it.variant_id)===line.variant_id && (it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.id : null)===plan; })[0];
    if(same){ same.quantity++; same.final_line_price+=same.final_price || line.final_price; same.original_line_price+=same.original_price || line.original_price; }   // same line → Shopify adds 1
    else c.items.push(line);
    c.currency=cur; c.total_price=(c.total_price || 0)+line.final_price;
    return c;
  }
  function showAddingWait(){
    var w=$('wait'); w.innerHTML='<span class="cd-spin" aria-hidden="true"></span>Adding to your cart&hellip;'; w.hidden=false;
    ['empty','items','gifts','benefits','footer'].forEach(function(k){ $(k).hidden=true; });
  }
  function showPending(kind, b){
    var pc=pendingCart(kind, b);
    if(!pc){ showAddingWait(); return; }
    var real=cart; cart=pc;   // render() reads the module cart · swapped for this one synchronous render only
    try{ render(); } finally{ cart=real; }
  }
  function afterFailedAdd(){   // nothing was added → drawer content back to the last real cart (or the start state)
    if(cart){ render(); return; }
    var w=$('wait'); w.textContent='Loading your cart\u2026'; w.hidden=false;
    ['empty','items','gifts','benefits','footer'].forEach(function(k){ $(k).hidden=true; });
    $('count').hidden=true;
  }

  var adding=false;
  function addFromFunnel(kind, btn){
    if(adding) return; adding=true;
    var label=btn.textContent, b=selectedBags();
    btn.classList.add('is-adding'); btn.setAttribute('aria-disabled','true'); btn.textContent='Adding…';
    // drawer opens NOW with the pending line · busy + is-loading: clicks inside (plan, qty, checkout) wait for the real cart
    busy++; drawer.classList.add('is-loading','is-adding'); drawer.setAttribute('aria-busy','true');
    try{ showPending(kind, b); }catch(e){ showAddingWait(); }
    open(btn);
    chain=chain.then(function(){ return configReady(); }).then(function(){
      var vid=CFG.variants[b], items=[{id:vid, quantity:1}];
      if(kind==='sub'){
        items[0].selling_plan=CFG.plans[b];
        CFG.gifts.forEach(function(g){ items.push({id:g, quantity:1, properties:{_subProduct:'true'}, parent_id:vid}); });   // exactly like the PDP form
      }
      return req('/cart/add.js', {items:items}).catch(function(e){
        if(items.length<2) throw e;
        console.warn('[LP cart] add with gifts failed, adding the plan alone:', errText(e));
        return req('/cart/add.js', {items:[items[0]]});   // never lose the sale · reconcile retries the gifts
      });
    }).then(function(){
      return refresh().catch(function(e){ console.error('[LP cart] refresh after add failed:', errText(e)); renderError(); });
    }).then(function(){
      joinMenWorld();
    }, function(e){
      close(); afterFailedAdd();   // nothing was added: the drawer closes again, toast like before
      toast('Could not add to cart: '+errText(e), 'error');
    }).then(null, function(){}).then(function(){
      adding=false; btn.classList.remove('is-adding'); btn.removeAttribute('aria-disabled');
      var on=D.querySelector('.bb-plans .bb-plan.on');
      btn.textContent = (btn.id==='bbOnce' && on && on.getAttribute('data-once')) ? on.getAttribute('data-once') : label;
      drawer.classList.remove('is-adding'); drawer.removeAttribute('aria-busy');
      if(--busy<=0){ busy=0; drawer.classList.remove('is-loading'); }
    });
  }
  var atc=D.querySelector('.bb-atc'), once=D.getElementById('bbOnce');
  function plainClick(e){ return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button!==0)); }   // cmd/ctrl-click keeps the PDP link
  if(atc){ atc.addEventListener('click', function(e){ if(!plainClick(e)) return; e.preventDefault(); addFromFunnel('sub', atc); }); atc.addEventListener('pointerdown', function(){ loadConfig(); }, {passive:true}); }
  if(once){ once.addEventListener('click', function(e){ if(!plainClick(e)) return; e.preventDefault(); addFromFunnel('once', once); }); once.addEventListener('pointerdown', function(){ loadConfig(); }, {passive:true}); }

  // ---------- drawer events (delegation · survives re-render) ----------
  function closeMenus(except){
    [].forEach.call(drawer.querySelectorAll('.cd-plan-menu'), function(m){ if(m!==except) m.hidden=true; });
    [].forEach.call(drawer.querySelectorAll('[data-cd-plan-toggle]'), function(b){ if(!except || b.parentNode!==except.parentNode) b.setAttribute('aria-expanded','false'); });
  }
  function pickPlan(opt){
    var li=opt.closest('.cd-item'); closeMenus();
    if(!li || opt.classList.contains('is-selected')) return;
    var k=opt.getAttribute('data-plan-key');
    mutate(function(){ return changePlan(li.getAttribute('data-key'), li.getAttribute('data-variant-id'), k); });
  }
  back.addEventListener('click', close);
  drawer.addEventListener('click', function(e){
    var t=e.target;
    if(t.closest('[data-cd-close]')){ close(); return; }
    var tg=t.closest('[data-cd-plan-toggle]');
    if(tg){
      var menu=tg.parentNode.querySelector('.cd-plan-menu'), willOpen=menu.hidden;
      closeMenus(); menu.hidden=!willOpen; tg.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    var opt=t.closest('.cd-plan-option');
    if(opt){ pickPlan(opt); return; }
    if(!t.closest('.cd-plan-menu')) closeMenus();
    if(t.closest('[data-cd-upgrade]')){ mutate(upgrade); return; }
    if(t.closest('[data-cd-back]')){
      e.preventDefault(); close();
      var o=D.getElementById('offer'); if(o) o.scrollIntoView({behavior:'smooth', block:'start'});
      return;
    }
    var co=t.closest('[data-cd-checkout]');
    if(co && busy>0){   // theme: finish a running cart update before leaving for checkout
      e.preventDefault();
      var dest=co.getAttribute('href') || '/checkout';
      chain.then(function(){ W.location.href=dest; });
    }
  });
  drawer.addEventListener('change', function(e){
    var s=e.target.closest('[data-cd-qty]'); if(!s) return;
    var li=s.closest('.cd-item'); if(!li) return;
    var q=parseInt(s.value, 10); if(isNaN(q)) return;
    mutate(function(){ return setQty(li.getAttribute('data-key'), li.getAttribute('data-variant-id'), q); });
  });
  drawer.addEventListener('keydown', function(e){
    var opt=e.target.closest && e.target.closest('.cd-plan-option');
    if(opt && (e.key==='Enter' || e.key===' ')){ e.preventDefault(); pickPlan(opt); }
  });
  D.addEventListener('keydown', function(e){ if(e.key==='Escape' && isOpen()) close(); });
  // back from checkout (bfcache restore with the drawer still open) → show the real cart again
  W.addEventListener('pageshow', function(e){ if(e.persisted && isOpen()) mutate(function(){}); });

  // page always starts at the top (Dominik 24.10.2026: "die page jumpt gleich auf die offer box, das soll nicht sein"): no browser
  // scroll restoration on reload, no leftover #offer in the address (#cart is handled below), and the CTA links scroll to their
  // section without writing the #anchor into the address
  try{ if('scrollRestoration' in history) history.scrollRestoration='manual'; }catch(e){}
  if(location.hash && location.hash!=='#cart'){ try{ history.replaceState(null, '', location.pathname+location.search); }catch(e){} }
  if(location.hash!=='#cart'){ var _h=D.documentElement, _sb=_h.style.scrollBehavior; _h.style.scrollBehavior='auto'; W.scrollTo(0,0); _h.style.scrollBehavior=_sb; }
  D.addEventListener('click', function(e){
    if(e.defaultPrevented || !plainClick(e)) return;
    var a=e.target.closest && e.target.closest('a[href^="#"]');
    if(!a || a.closest('#lpcd')) return;
    var id=a.getAttribute('href').slice(1), el=id && D.getElementById(id);
    if(!el) return;
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth', block:'start'});
  });

  // men's world (Dominik 24.10.2026: "oben auf den Cart klickt, dass dann der Cart Drawer wiederkommt · der Male Cart"): this page is the
  // way back; after an add the visitor joins the men's theme (same hop as the Strength PDP), so the cart icon in checkout → /cart
  // (men's theme, layout #men-exit) → back here with #cart → this drawer opens again
  var MEN_THEME='206800453972';
  try{ localStorage.setItem('myo_men_return', location.pathname); }catch(e){}
  function joinMenWorld(){ try{ fetch('/cart?preview_theme_id='+MEN_THEME, {credentials:'same-origin'}).catch(function(){}); }catch(e){} }
  if(location.hash==='#cart'){
    try{ history.replaceState(null, '', location.pathname+location.search); }catch(e){}
    refresh().then(function(){ open(); }).catch(function(){});
  }

  // small API for checks / other page code
  W.LP_CART={open:function(){ return refresh().then(function(){ open(); }); }, close:close, refresh:refresh, config:CFG};
})();